var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"c8c91ece7acf8fda2db4c6772d6fbfb4ce29f598"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "/unity-mkt-services-prd-ui-static/marketplace/c8c91ece7acf8fda2db4c6772d6fbfb4ce29f598";

// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/nextjs';
import {
  beforeSend,
  denyUrls,
  dsn,
  environment,
  ignoreErrors,
  sampleRate,
  tracesSampler,
} from './sentry.shared';

Sentry.init({
  // Have to use NEXT_PUBLIC since regular environment variables aren't accessible on the client side
  environment,
  // Undefined outside the deployed environments, which disables the SDK — see sentry.shared.ts
  dsn,
  // Shared sampler. Its exclusions are all server/edge transactions, so in the
  // browser only the fall-through rate applies. Takes precedence over
  // `tracesSampleRate`, so that option is deliberately not set alongside it.
  tracesSampler,
  // Full rate in the environments we triage, reduced for PR previews — see sentry.shared.ts
  sampleRate,
  // Browser noise we can't act on: network failures we don't cause, and errors
  // thrown by extensions and userscripts injected into the page
  ignoreErrors,
  denyUrls,
  // denyUrls can't see all-anonymous stacks; this catches them
  beforeSend,
  // browserTracingIntegration is enabled by default by sentry/nextjs, but if we want to pass any custom config we can do it here
  // only needed in the client config
  integrations: [Sentry.browserTracingIntegration({ enableInp: true })],
  // ...
  // Note: if you want to override the automatic release value, do not set a
  // `release` value here - use the environment variable `SENTRY_RELEASE`, so
  // that it will also get attached to your source maps
});

if (process.env.NEXT_PUBLIC_EPHEMERAL_PR_NUMBER) {
  Sentry.setTag('ephemeral_pr', process.env.NEXT_PUBLIC_EPHEMERAL_PR_NUMBER);
}
